import { Component } from "preact";
import { h } from "preact";
import * as style from "../../common/components/form-elements/ComboBox/ComboBox.less";
import { fromStyleLocals } from "../../common/utils/css";
const css = fromStyleLocals(style.locals);

// tslint:disable-next-line: interface-name
interface StepItem {
  Text: string;
  Val: string;
}

const serverError = "Server error";

export type Status = "Loading" | "Unauthorized" | "Server error" | "Success";
// tslint:disable-next-line:interface-name
interface Props {
  onChange: (tags: string[]) => void;
  tags: string[];
  getItems: () => Promise<StepItem[]>;
}

// tslint:disable-next-line:interface-name
interface State {
  selected: string;
  status: Status;
  statusClass: string;
  items: StepItem[];
}

export class StepSelector extends Component<Props, State> {
  public componentWillMount() {
    const defaultValue =
      this.props === undefined || this.props.tags === undefined
        ? this.state.selected
        : this.getExistingTag(this.props);
    this.setState({
      items: [],
      selected: defaultValue,
      status: "Loading",
      statusClass: "",
    });
    this.props.onChange([defaultValue]);
  }

  public componentDidMount() {
    this.makeApiCall();
  }

  public render() {
    return (
      <div class="form-group">
        {this.state.status !== "Success" ? (
          <div class={css("list-group")}>
            {this.renderStatus(this.state.status)}
          </div>
        ) : (
          <select
            class="form-control"
            id="select"
            onChange={this.valueChanged.bind(this)}
            value={this.state.selected}
          >
            {this.state.items.map(item => (
              <option value={item.Val}>{item.Text}</option>
            ))}
          </select>
        )}
      </div>
    );
  }

  private renderStatus(status: string) {
    return (
      <div>
        {this.state.status === "Loading" ? (
          <span class={css("list-group-item")}>
            <i class="fa fa-spinner fa-pulse fa-fw" />
            Loading...
          </span>
        ) : (
          <span class={css("list-group-item")} style="color:#b9292d">
            <i class={css(this.state.statusClass)} />
            {status}
          </span>
        )}
      </div>
    );
  }

  private async makeApiCall() {
    if (
      this.state.status !== serverError &&
      this.state.status !== "Unauthorized"
    ) {
      await this.props
        .getItems()
        .then(value => this.handleSuccess(value))
        .catch(err => this.handleError(err));
    }
  }

  private valueChanged(evt: any) {
    this.setState({
      selected: evt.target.value,
    });
    this.props.onChange([evt.target.value]);
  }

  private getExistingTag(props: Props) {
    if (
      props === undefined ||
      props.tags === undefined ||
      props.tags.length !== 1
    ) {
      return "4";
    }
    return props.tags[0];
  }

  private handleError(error: any) {
    if (error.toString().indexOf("Unauthorized") > -1) {
      this.setState({
        ...this.state,
        status: "Unauthorized",
        statusClass: "fa fa-ban",
      });
    } else {
      this.setState({
        ...this.state,
        status: serverError,
        statusClass: "fa fa-times",
      });
    }
  }

  private handleSuccess(result: any) {
    if (result) {
      this.setState({ ...this.state, items: result, status: "Success" });
    }
  }
}
